import { render, staticRenderFns } from "./TabDraft.vue?vue&type=template&id=6920fa0b&scoped=true&"
import script from "./TabDraft.vue?vue&type=script&lang=js&"
export * from "./TabDraft.vue?vue&type=script&lang=js&"
import style0 from "./TabDraft.vue?vue&type=style&index=0&id=6920fa0b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6920fa0b",
  null
  
)

export default component.exports